<input matInput #input [formControl]="formControl" [placeholder]="placeholder" type="text">
